import { useEffect, useState } from 'react'
import { OrderBreadType } from 'types/bread'
import { CheckoutItemType } from 'types/checkoutItem'
import { findBreadShortName } from 'lib/helper'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'

const useOrdersByBread = (items: CheckoutItemType[]): OrderBreadType[] => {
  const breads = useSelector((state: State) => getBreads(state))
  const [ordersByBread, setOrdersByBread] = useState<OrderBreadType[]>([])
  // パン > 受渡解禁時間 > 受渡オプションの階層構造となるようデータ整形
  useEffect(() => {
    const _ordersByBread: OrderBreadType[] = []
    for (let i = 0; i < items.length; i = (i + 1) | 0) {
      const item = items[i]
      // パンのリストに存在しているか確認
      const x = _ordersByBread.findIndex((bread) => bread.breadRef.id === item.bread_ref.id)
      if (x === -1) {
        _ordersByBread.push({
          breadName: findBreadShortName(breads, item.bread_name, item.bread_ref),
          breadRef: item.bread_ref,
          manufacturerName: item.manufacturer_name,
          storeName: item.store_name,
          pickupable_times: [
            {
              pickupable_time: item.pickupable_time,
              choices: [
                {
                  choice: item.choice,
                  quantity: item.quantity,
                },
              ],
            },
          ],
        })
      } else {
        // パンの受渡解禁時間リストに存在しているか確認
        const times = _ordersByBread[x].pickupable_times
        const y = times.findIndex((time) => time.pickupable_time === item.pickupable_time)
        if (y === -1) {
          _ordersByBread[x].pickupable_times.push({
            pickupable_time: item.pickupable_time,
            choices: [
              {
                choice: item.choice,
                quantity: item.quantity,
              },
            ],
          })
        } else {
          // 受渡解禁時間ごとの受渡オプションに存在しているか確認
          const choices = _ordersByBread[x].pickupable_times[y].choices
          const z = choices.findIndex((choice) => choice.choice === item.choice)

          if (z === -1) {
            _ordersByBread[x].pickupable_times[y].choices.push({
              choice: item.choice,
              quantity: item.quantity,
            })
          } else {
            _ordersByBread[x].pickupable_times[y].choices[z] = {
              choice: item.choice,
              quantity: _ordersByBread[x].pickupable_times[y].choices[z].quantity + item.quantity,
            }
          }
        }
      }
    }
    _ordersByBread.sort((a, b) => {
      const aBread = breads.find((bread) => bread.bread_ref?.id === a.breadRef.id)
      const bBread = breads.find((bread) => bread.bread_ref?.id === b.breadRef.id)
      // bread の order の昇順で並び替える
      return (aBread?.order || 9999) - (bBread?.order || 9999)
    })
    setOrdersByBread([..._ordersByBread])
  }, [items])
  return ordersByBread
}

export default useOrdersByBread
